import React, { useEffect, useState } from 'react';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import TopUpTable from './subcomponents/TopUpTable';
import NoNumbers from './subcomponents/NoNumbers';
import AddNumberDialog from './subcomponents/AddNumberDialog';
import { DepartmentsService } from 'services/departments/departments';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';
import { AccountsService } from 'services/accounts/accounts';
import { SingleAccount } from 'utils/api/models/accounts/singleAccount';

interface IndexProps {
	showTable: boolean;
	showDialog: boolean;
	handleTopUp: () => void;
	topupValue: number;
	handleAddNumber: () => void;
	setTopupValue: React.Dispatch<React.SetStateAction<number>>;
	totalAmount: number;
	selectedNumbers: types.topUp.INumber[];
	possibleNumbers: SingleAccount[];
	setSelectedNumbers: React.Dispatch<React.SetStateAction<types.topUp.INumber[]>>;
	closeDialog: () => void;
	handleAdd: (numbers: Array<SingleAccount>) => void;
}

const Index = (props: IndexProps) => {
	const {
		showTable,
		showDialog,
		handleTopUp,
		handleAddNumber,
		setTopupValue,
		topupValue,
		totalAmount,
		selectedNumbers,
		setSelectedNumbers,
		closeDialog,
		possibleNumbers,
		handleAdd,
	} = props;

	const [departmentsFetched, setDepartmentsFetched] = useState<{ [key: string]: SingleDepartment }>({});
	const [accounts, setAccounts] = useState<{ [key: string]: SingleCorpAccount }>({});

	useEffect(() => {
		AccountsService.getCorpAccountsForCurrentUser().subscribe(({ accounts }) =>
			setAccounts(accounts.reduce((acc, account) => ({ ...acc, [account.accountId]: account }), {}))
		);
	}, []);

	useEffect(() => {
		DepartmentsService.getDepartmentsForCurrentUser().subscribe(({ departments }) => {
			const preparedDepartments = departments
				.filter((department) => department.deptId)
				.reduce((acc, department) => ({ ...acc, [department.deptId]: department }), {});
			setDepartmentsFetched(preparedDepartments);
		});
	}, []);

	return (
		<>
			<ConditionalRender
				show={showTable}
				onTrue={() => (
					<TopUpTable
						departments={departmentsFetched}
						accounts={accounts}
						selectedNumbers={selectedNumbers}
						handleAddNumber={handleAddNumber}
						topupValue={topupValue}
						setTopupValue={setTopupValue}
						setSelectedNumbers={setSelectedNumbers}
						totalAmount={totalAmount}
						handleTopUp={handleTopUp}
					/>
				)}
				onFalse={() => <NoNumbers handleAddNumber={handleAddNumber} />}
			/>
			<ConditionalRender
				show={showDialog}
				onTrue={() => (
					<AddNumberDialog
						isOpen
						accounts={accounts}
						onClose={closeDialog}
						numbers={possibleNumbers}
						handleAdd={handleAdd}
						departmentsFetched={departmentsFetched}
					/>
				)}
			/>
		</>
	);
};

export default Index;
